import styled from '@emotion/styled'
import { gsColors } from '../../../styles/Variables'
import { mq } from '../../../helpers'
import { Section, H1_Base, H2_Base } from '../../../styles/Components'

export const PaymentSection = styled(Section)`
margin: 0;
padding: ${props => (props.account ? '0' : '30px 24px 18px')};

${mq('min', '1024px')} {
min-width: ${props => (props.account ? '500px' : '422px')};
padding: ${props => (props.account ? '0' : '50px 60px')};
}

${mq('max', '768px')} {
  margin: 0 16px;
}

.payment-error {
  color: ${gsColors.errorRed};
  font-family: Euclid;
  font-size: 14px;
  margin: 0 0 24px;
  text-align: center;
}

.payments-account-view {
  .default-payment {
    padding: 0 0 24px 0;

    div {
      display: flex;
      align-items: center;
      justify-content: space-between;

      button {
        min-width: 0px;
        width: max-content;
      }
    }
  }

  .other-payments {
    padding: 24px 0;
    border-top: 1px solid #D9D9D9;

    .other-payments-list {
      display: flex;
      flex-direction: column;
      gap: 24px;

      .other-payment-item {
        position: relative;

        .payment-content {
          display: flex;
          align-items: center;
          justify-content: space-between;
          flex-wrap: wrap;
          gap: 20px;

          & > div {
            display: flex;
          }

          .payment-method-actions {
            display: flex;
            gap: 32px;
          }

        }
      }
    }
  }
}

.payment-method-select {
margin: 30px 0;
position: relative;

&.open {
> .payment-method-summary {
  // border-color: transparent;
  // box-shadow: 0 0 4px 0 ${gsColors.cobalt};
  }

  .menu {
    opacity: 1;
    max-height: 500px;

    ul {
      li {

        &.add-payment-li {
          padding: 0px !important;
        }

        button {
          visibility: visible;
        }
      }
    }

    .add-payment-method {

    }
  }
}

> .payment-method-summary {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #fff;
  border: none;
  border-bottom: 1px solid ${props => (props.error ? gsColors.errorRed : '#000')};
  cursor: pointer;
  display: flex;
  align-items: center;
  font-family: Euclid;
  font-size: 18px;
  height: 54px;
  overflow: hidden;
  text-overflow: ellipsis;
  transition: all 250ms;
  white-space: nowrap;
  width: 100%;
  position: relative;

  div {
    display: flex;
    align-items: center;
  }

  .down-arrow-icon {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 12px;
  }
}

.menu {
    background-color: ${gsColors.white};
    border-left: 1px solid ${gsColors.greyPoupon};
    border-right: 1px solid ${gsColors.greyPoupon};
    box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.06), 0px 4px 6px 0px rgba(0, 0, 0, 0.10);
    max-height: 0;
    opacity: 0;
    overflow: hidden;
    position: absolute;
    top: 100%;
    left: 0;
    transition: all 400ms ease-out;
    width: 100%;
    z-index: 500;

    ul {
      li {
        background-color: white;
        border: none;
        border-bottom: 1px solid ${gsColors.greyPoupon};
          font-size: 18px;
          line-height: 100%;
          font-family: Euclid;
          text-align: left;
          padding: 13px 20px;
          font-weight: 400;
          color: #000;

        }
      }


      .saved-payment-methods {
        max-height: 170px;
        overflow-y: auto;
        height: 100%;
        width: 100%;

        > li {
          cursor: pointer;
          display: flex;
          align-items: center;
          transition: background-color 250ms;
          width: 100%;

          .card-select {
            padding: 0;
            background-color: transparent;
            border: none;
            height: 100%;
            width: 100%;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            // padding-left: 1rem;
            font-family: Euclid;
            font-size: 18px;

            div {
              display: flex;
              align-items: center;
            }

            &:hover {
              cursor: pointer;
            }

            /* Check badge on the selected row, pinned to the right edge. */
            .selected-check {
              flex: 0 0 auto;
              height: 24px;
              margin-left: auto;
              margin-right: 20px;
            }
          }

          /* QA: rows keep black text in every state — the old solid-cobalt
             selected fill made the label illegible. Hover is eggshell (no
             check); selected is sand (with the check badge). Selected comes
             last so it wins over hover on the already-selected row. */
          &:hover {
            background-color: ${gsColors.eggshell};
          }

          &.selected {
            background-color: ${gsColors.sand};
            }
          }
        }

          .payment-method-summary {
            font-size: 14px;
            line-height: 1.57;
          }

          .add-payment-method {
            background-color: transparent;
            border: none;
            font-size: 18px;
            line-height: 100%;
            font-family: Euclid;
            text-align: left !important;
            font-weight: 400;
            color: ${gsColors.sunsetOrange};
            width: 100%;
            height: 100%;
            padding: 13px 20px;

            &:hover {
              cursor: pointer;
            }

            ${mq('max', '768px')} {
              font-size: 14px;
            }
          }
        }
      }

      .payment-account-footer {
        margin-top: 50px;
        display: flex;

        ${mq('max', '530px')} {
        flex-direction: column;

        button {
          width: 100%;
          flex: 1;
        }
      }

      .protection {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        flex: 1;

        ${mq('max', '530px')} {
        margin-top: 30px;
        align-items: flex-start;
        flex-direction: row;
        gap: 16px;
      }


      h2 {
        margin: 0;
        max-width: 170px;
        text-align: left;
      }

      img {
        max-height: 22px;

        ${mq('min', '768px')} {
        max-height: 26px;
      }
    }
  }
}

`

export const H1 = styled(H1_Base)`
margin-bottom: 10px;
text-align: center;

${mq('min', '768px')} {
  font-size: 24px;
  line-height: 1;
}
`

export const H2 = styled(H2_Base)`
margin-bottom: 30px;
text-align: center;
`

export const PaymentH1 = styled(H1)`
margin: 0 auto 10px;
max-width: 280px;
`

export const CheckoutWrapper = styled.div`
align-items: flex-start;
display: flex;
flex-direction: column;
padding: 70px 0;
width: 85%;

${mq('max', '768px')} {
  width: 100%;
}

.payment-card-container {
  section {
    padding: 0;
  }
}

.order-summary-container {
  display: flex;
  flex-direction: column;
  gap: 40px; 

  .complete-button-container {
  ${mq('max', '768px')} {
    padding: 0 16px;
  }
}
}

.checkout-actions {
  display: flex;
  width: 100%;
  gap: 100px;
  // height: 100%;
  justify-content: center;
  ${mq('max', '768px')} {
    gap: 40px;
  }
}

${mq('max', '768px')} {
  padding: 50px 0px;
  height: auto;

  .checkout-header {
    padding: 0 20px;
  }

  .subtitle {
    font-size: 18px;
  }

  .checkout-actions {
    flex-direction: column;
  }
}
`

export const OrderSummaryContainer = styled.div`
width: 100%;
background-color: ${gsColors.khaki};
display: flex;
flex-direction: column;
text-align: center;
align-items: center;
padding: 37px 107px;
// margin-bottom: ${props => (props.marginBottom ? props.marginBottom : '')};

${mq('max', '768px')} {
  padding: 37px 16px;
}
.order-details {
  width: 100%;
}

.gift-card-summary {
width: 100%;

.gift-card-summary-title {
display: flex;
justify-content: space-between;

h3 {
  font-family: Garnett;
  font-weight: 750;
}

.edit-gift-button {
  cursor: pointer;
  font-family: Euclid;
  font-size: 18px;
  border: none;
  background-color: transparent;
  font-style: normal;
  font-weight: 600; 
  letter-spacing: 0.72px;
  color: ${gsColors.sunsetOrange};
  }
}

.gift-card-details {
  margin-top: 1rem;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;

  p {
    text-align: left;
    .recipient-info-name {
      color: ${gsColors.venus};
      }
    }

    button {
      min-width: initial;
      padding: 14px 0;
    }
  }
}

.prices {
width: 100%;
margin-top: 38px;

ul {
width: 100%;
li {
  color: ${gsColors.venus};
    font-size: 14px;
    text-align: left;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 6px;
    width: 100%;

    div {
      width: 100%;
      display: flex;
      justify-content: space-between;
    }
  }
}

.total {
color: ${gsColors.black};
font-size: 18px;
font-weight: bold;
padding: 20px 0;
text-transform: uppercase;
border-top: 2px solid black;
}

.promo {
color: ${gsColors.cobalt};
}

.order-detail-items {
  padding: 30px 0;

  li {
    padding-bottom: 12px;
    p {
      font-weight: 500;
    }
  }
}

.order-item {
  color: ${gsColors.black};
    display: flex;
    flex-direction: column;
    width: 100%;

    div {
      display: flex;
      width: 100%;
      justify-content: space-between;
    }

    button {
      min-width: initial;
      padding: 0;
    }
  }
}
`

export const ConfirmationWrapper = styled.div`
display: flex;
align-items: center;
flex-direction: column;
padding: 0 20px;

text-align: center;
height: calc(100vh - 70px);
width: 100%;

h1 {
  margin-top: 80px;

  ${mq('max', '1015px')} {
  margin-top: 180px !important;
}
}

h2 {
margin-top: 25px;
line-height: 48px;
}

h1,
h2 {
max-width: 800px;
text-align: center;
}

.title {
  margin-top: 80px;
}

.thank-you {
  margin-top: 25px;
  line-height: 48px;
}

.subtitle {
  margin: 50px 0;
  width: 400px;
  span,
  p {
    color: ${gsColors.venus};
      font-size: 18px;
      text-align: center;
    }
  }

  a {
    width: 300px;
    height: 52px;
    font-size: 16px;
    text-transform: uppercase;
  }

  ${mq('max', '485px')} {
  .thank-you {
    font-size: 21px;
    line-height: 28px;
  }

  .subtitle {
    width: 80%;
  }

  a {
    width: 80%;
  }
}
`

export const CheckoutContainer = styled.div`
display: flex;
justify-content: center;
align-items: center;
height: 100%;
width: 100vw;
overflow-y: scroll;
`

export const DestroyPaymentModal = styled.div`
display: flex;
flex-direction: column;
align-items: center;
justify-content: center;
padding: 0rem 1rem 2rem;

.options {
  display: flex;
  width: 100%;
  justify-content: center;
  flex-wrap: wrap;
  gap: 16px;
  max-width: 80%;
  button {
    margin: 0;
    flex: 1;
  }
}
`
export const Divider = styled.div`
border-top: 0.5px solid ${gsColors.paleSlate};
margin: 1rem 2rem 0 2rem;
display: inline-block;
max-width: 80%;
padding: 0 2rem;
left: 50%;
transform: translateX(-50%);
`
